/* EGG RAW for Business: checkout "last push" for business carts.
   When the cart holds a one-time EGG RAW for Business order, Secure checkout opens a B2B weekly-supply offer
   instead of the consumer popup, and the consumer trial-code chip is hidden. Prices are before GST and must
   match the Easy Subscriptions plans (weekly ₹826 / ₹1,239 / ₹1,652 off per delivery). */
(() => {
  const PLANS = {
    10: { week: 399, once: 469 },
    15: { week: 389, once: 459 },
    20: { week: 379, once: 449 }
  };
  const inr = (n) => '₹' + Math.round(n).toLocaleString('en-IN');
  const b2bUrl = () => {
    try { return sessionStorage.getItem('eggrawB2bUrl') || '/pages/eggraw-for-business'; } catch (e) { return '/pages/eggraw-for-business'; }
  };

  /* Business line in the cart page or drawer: litres. */
  const b2bLine = () => {
    const rows = document.querySelectorAll('.cart-items__table-row, .cart-item, [data-cart-item]');
    for (const row of rows) {
      if (!/for Business/i.test(row.textContent)) continue;
      const m = row.textContent.match(/(\d+)\s*L\s*·/);
      const litres = m ? Number(m[1]) : 10;
      return { row, litres: PLANS[litres] ? litres : 10 };
    }
    return null;
  };

  /* Hide the consumer trial-code chip: find its smallest text node, then its chip container only. */
  const hideTrialChip = () => {
    document.querySelectorAll('strong, b, span, p, small').forEach((el) => {
      if (el.children.length || !/Not ready to subscribe/i.test(el.textContent)) return;
      const box = el.closest('[class*="trial"], [data-er-trial], [class*="chip"]');
      if (box && !box.contains(document.querySelector('.cart-items__table-row'))) box.style.display = 'none';
    });
  };

  let dlg;
  const build = () => {
    const style = document.createElement('style');
    style.textContent = `
#eggraw-b2b-offer{border:0;padding:0;border-radius:22px;max-width:440px;width:calc(100% - 28px);background:#fffdf6;color:#102922;box-shadow:0 24px 70px rgba(0,0,0,.28);font-family:inherit}
#eggraw-b2b-offer::backdrop{background:rgba(9,32,24,.55)}
#eggraw-b2b-offer .bo-in{padding:26px 22px 20px;position:relative}
#eggraw-b2b-offer .bo-x{position:absolute;right:12px;top:10px;border:0;background:none;font-size:26px;line-height:1;color:#53634f;cursor:pointer;padding:6px}
#eggraw-b2b-offer .bo-tag{display:inline-block;background:#daece3;color:#0b3d2e;font-size:11px;font-weight:800;letter-spacing:.08em;padding:6px 10px;border-radius:999px}
#eggraw-b2b-offer h2{margin:12px 0 6px;font-size:26px;line-height:1.08;font-weight:850;letter-spacing:-.02em;text-transform:none}
#eggraw-b2b-offer h2 em{font-style:normal;color:#005747;box-shadow:inset 0 -.35em 0 #ffe27a}
#eggraw-b2b-offer .bo-sub{margin:0 0 14px;font-size:14px;line-height:1.45;color:#33443c}
#eggraw-b2b-offer .bo-card{border:1.5px solid #0b3d2e;background:#eaf4ec;border-radius:16px;padding:14px 16px;display:flex;justify-content:space-between;align-items:center;gap:10px}
#eggraw-b2b-offer .bo-card b{font-size:26px;font-weight:850}
#eggraw-b2b-offer .bo-card small{display:block;font-size:12px;color:#33443c;margin-top:2px}
#eggraw-b2b-offer .bo-card s{color:#8a978c;font-size:14px}
#eggraw-b2b-offer ul{list-style:none;margin:14px 0 16px;padding:0;display:grid;grid-template-columns:1fr 1fr;gap:8px 12px;font-size:13px;font-weight:700}
#eggraw-b2b-offer li::before{content:'✓ ';color:#005747;font-weight:900}
#eggraw-b2b-offer .bo-go{display:block;width:100%;border:0;border-radius:999px;background:#0b3d2e;color:#fff;font-size:16px;font-weight:800;padding:15px 18px;cursor:pointer}
#eggraw-b2b-offer .bo-once{display:block;width:100%;margin-top:8px;border:1.5px solid #c9d8cc;border-radius:999px;background:#fff;color:#102922;font-size:14px;font-weight:700;padding:12px 18px;cursor:pointer}
#eggraw-b2b-offer .bo-note{margin:10px 0 0;font-size:11px;color:#6b7a6f;text-align:center}`;
    document.head.appendChild(style);
    dlg = document.createElement('dialog');
    dlg.id = 'eggraw-b2b-offer';
    dlg.setAttribute('aria-labelledby', 'bo-title');
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  };

  const open = (line) => {
    if (!dlg) build();
    const p = PLANS[line.litres];
    const L = line.litres;
    dlg.innerHTML = `<div class="bo-in">
      <button type="button" class="bo-x" aria-label="Close">×</button>
      <span class="bo-tag">WEEKLY KITCHEN SUPPLY</span>
      <h2 id="bo-title">Make it weekly.<br><em>Save ${inr((p.once - p.week) * L * 4)}</em> every 4 weeks.</h2>
      <p class="bo-sub">The same ${L} L, delivered chilled every week at ${inr(p.week)}/L instead of ${inr(p.once)}/L.</p>
      <div class="bo-card"><div><b>${inr(p.week)}/L</b><small>+ GST · ${inr(p.week * L * 4)} + GST every 4 weeks</small></div><s>${inr(p.once)}/L</s></div>
      <ul><li>Price locked 90 days</li><li>Free chilled delivery</li><li>Skip, pause or cancel</li><li>GST invoice</li></ul>
      <button type="button" class="bo-go">Switch to weekly supply →</button>
      <button type="button" class="bo-once">Continue with one-time order</button>
      <p class="bo-note">Saving vs four one-time orders, before GST.</p>
    </div>`;
    dlg.querySelector('.bo-x').onclick = () => dlg.close();
    dlg.querySelector('.bo-once').onclick = () => { dlg.close(); location.href = '/checkout'; };
    dlg.querySelector('.bo-go').onclick = async (e) => {
      e.currentTarget.disabled = true;
      try {
        const cart = await (await fetch('/cart.js')).json();
        const updates = {};
        cart.items.forEach((it) => { if (/for Business/i.test(it.product_title)) updates[it.key] = 0; });
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      } catch (err) { /* keep going to the buy box */ }
      const url = new URL(b2bUrl(), location.origin);
      url.searchParams.set('litres', L);
      url.hash = 'shop-eggraw';
      location.href = url.pathname + url.search + url.hash;
    };
    dlg.showModal();
  };

  const onCheckout = (e) => {
    const btn = e.target.closest && e.target.closest('#checkout, [name="checkout"], .cart__checkout-button');
    if (!btn) return;
    const line = b2bLine();
    if (!line) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(line);
  };
  window.addEventListener('click', onCheckout, true);
  window.addEventListener('submit', (e) => {
    if (e.submitter && e.submitter.name === 'checkout' && b2bLine()) { e.preventDefault(); e.stopImmediatePropagation(); open(b2bLine()); }
  }, true);

  const tidy = () => { if (b2bLine()) { hideTrialChip(); document.documentElement.classList.add('er-b2b-cart'); } };
  document.addEventListener('DOMContentLoaded', tidy);
  new MutationObserver(() => { clearTimeout(tidy.t); tidy.t = setTimeout(tidy, 200); }).observe(document.documentElement, { childList: true, subtree: true });
})();
